import { siteMeta } from "@/mocks/home";

const linkGroups = [
  {
    title: "入口导航",
    links: [
      { label: "当前可用域名", href: "#domains" },
      { label: "镜像站点索引", href: "#mirrors" },
      { label: "精选入口合集", href: "#collections" },
    ],
  },
  {
    title: "使用帮助",
    links: [
      { label: "入口更新日志", href: "#updates" },
      { label: "防走失指引", href: "#guide" },
      { label: "常见问题", href: "#faq" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-50 border-t border-primary-200">
      <div className="w-full max-w-[1180px] mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500">
                <i className="ri-vip-diamond-line text-lg text-background-50"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">{siteMeta.name}</span>
            </div>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed max-w-md">
              一个帮你找回入口的整理页。把最新地址、可用域名和镜像入口收在一处，原网址失效时不用再到处翻。
            </p>
            <p className="mt-4 text-xs text-foreground-500 flex items-center gap-1.5">
              <i className="ri-refresh-line"></i>
              最近更新 {siteMeta.updatedAt}
            </p>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title} className="md:col-span-3">
              <h5 className="font-heading text-[15px] text-foreground-950">{group.title}</h5>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1 flex md:justify-end">
            <a
              href="#top"
              aria-label="返回顶部"
              className="w-10 h-10 flex items-center justify-center rounded-md border border-primary-300 bg-background-50 text-primary-700 hover:bg-primary-100 cursor-pointer transition-colors"
            >
              <i className="ri-arrow-up-line text-lg"></i>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-foreground-500">
            本页为入口信息整理页，仅提供公开可访问地址的汇总与状态说明，不代表任何立场。
          </p>
          <p className="text-xs text-foreground-500">
            © 2026 {siteMeta.name} 入口索引 · 内容仅供参考
          </p>
        </div>
      </div>
    </footer>
  );
}